import { ThemeProvider } from "styled-components";
import { ecommReviews } from "@styles/SystemDesign";
import GlobalStyle from "@styles/GlobalStyle";

export default function ThemeRegistry({ children }: { children: React.ReactNode }) {
    return (
        <ThemeProvider theme={ecommReviews}>
            <GlobalStyle />
            {children}
        </ThemeProvider>
    );
}
